// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'

import {
  GlobalHeader,
  SecondaryNavigation,
  Menu,
  MenuItem,
  UserAccountMenu
} from '../'

import {   hasResponsibility } from '../../utils'


class GlobalNavigation extends React.PureComponent {
  state = {
    query: null,
    secondaryNavigationMenu: null,
    x: null,
    showUserMenu: null  // values can be 'null' or object of shape { user, employer }
  }

  getMenu = (currentAccountId, isEmployerGroupAccount) => {
    const urlHead = isEmployerGroupAccount
      ? `/group/${currentAccountId}`
      : `/employer/${currentAccountId}`

    switch (this.state.secondaryNavigationMenu) {
      case 'employees':
        return [
          <Menu
            to={`${urlHead}/employees`}
            onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            className='slds-m-left_large slds-p-left_large slds-p-right_large slds-p-bottom_large'
            key='employees'>
            <MenuItem
              name='Overview'
              to={`${urlHead}/employees/overview`}
              onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            />
            <MenuItem
              name='Listing'
              to={`${urlHead}/employees`}
              onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            />
            <MenuItem
              name='Requests'
              to={`${urlHead}/employees/requests`}
              onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            />
          </Menu>
        ]

      case 'employerComms':
        return [
          <Menu
            title='Bulk messaging'
            to={`${urlHead}/communications/bulk?tab=0`}
            onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            className='slds-m-left_large slds-p-left_large slds-p-right_large slds-p-bottom_large'
            key='employerComms_SMS'>
            <MenuItem
              name='Messages'
              to={`${urlHead}/communications/bulk?tab=0`}
              onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            />
            <MenuItem
              name='Bulk messages'
              to={`${urlHead}/communications/bulk?tab=1`}
              onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            />
            <MenuItem
              name='Compose bulk message'
              to={`${urlHead}/communications/bulk?tab=2`}
              onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            />
            <MenuItem
              name='Audiences'
              to={`${urlHead}/communications/bulk?tab=3`}
              onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            />
          </Menu>,
          <Menu
            title='WhatsApp'
            to={`${urlHead}/communications/whatsapp?tab=0`}
            onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            className='slds-m-left_large slds-p-left_large slds-p-right_large slds-p-bottom_large'
            key='employerComms_whatsapp'>
            <MenuItem
              name='Messages'
              to={`${urlHead}/communications/whatsapp?tab=0`}
              onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            />
            <MenuItem
              name='Editor'
              to={`${urlHead}/communications/whatsapp?tab=1`}
              onClick={() => this.setState({ secondaryNavigationMenu: null, query: null })}
            />
          </Menu>
        ]

      default:
        return []
    }
  }

  getNavLinks = (currentPageTabIndex, accountId, isEmployerGroupAccount) => {
    const defaultEmployerPortalNavLinks = [
      <li
        className={`slds-tabs_default__item ${currentPageTabIndex === 0 && 'slds-is-active'}`}
        onClick={() => this.props.history.push(`/dashboard`)}
        key='home'>
        <b>Home</b>
      </li>
    ]

    const urlHead = isEmployerGroupAccount
      ? `/group/${accountId}`
      : `/employer/${accountId}`

    const messagePlusNavLinks = [
      <li
        className={`slds-tabs_default__item ${currentPageTabIndex === 1 && 'slds-is-active'}`}
        onClick={() => this.props.history.push(`${urlHead}/employees`)}
        onMouseOver={() => this.setState({ secondaryNavigationMenu: 'employees', x: 280 })}
        key='employees'>
        <b>Employees</b>
      </li>,
      <li
        className={`slds-tabs_default__item ${currentPageTabIndex === 2 && 'slds-is-active'}`}
        onClick={() => this.props.history.push(`${urlHead}/communications/bulk`)}
        onMouseOver={() => this.setState({ secondaryNavigationMenu: 'employerComms', x: 340 })}
        key='communications'>
        <b>Communications</b>
      </li>,
      // <li
      //   className={`slds-tabs_default__item ${currentPageTabIndex === 3 && 'slds-is-active'}`}
      //   onClick={() => this.props.history.push(`/employer/${employerId}/payroll`)}
      //   onMouseOver={() => this.setState({ secondaryNavigationMenu: null, x: null })}
      //   key='payroll'>
      //   <b>Payroll</b>
      // </li>
    ]

    let navLinks = [...defaultEmployerPortalNavLinks]
    if (hasResponsibility('self', 'messageplus_user')) {
      navLinks = [...navLinks, ...messagePlusNavLinks]
    }

    return navLinks
  }

  getCurrentActivePageTabIndex = (pathname) => {
    switch(true) {
      case pathname.includes('employees'):
        return 1

      case pathname.includes('communications'):
        return 2

      case pathname.includes('payroll'):
        return 3

      default:
        return 0  // home
    }
  }

  render() {
    const currentPageTabIndex = this.getCurrentActivePageTabIndex(this.props.location.pathname)
    const { currentAccountId, isEmployerGroupAccount, switchAccount } = this.props

    return (
      <Fragment>
        <GlobalHeader
          accountId={currentAccountId}
          isEmployerGroupAccount={isEmployerGroupAccount}
          navigationLinks={this.getNavLinks(currentPageTabIndex, currentAccountId, isEmployerGroupAccount)}
          onUserClick={(userName, employerName) => (
            this.setState({
              showUserMenu: { userName, employerName }
            })
          )}
          hideSearch={true}
        />
        {this.state.showUserMenu
          ? <UserAccountMenu
              user={this.state.showUserMenu.userName}
              employerId={currentAccountId}
              employerName={this.state.showUserMenu.employerName}
              onEmployerSwitchClick={e => switchAccount(e.target.value)}
              onClickOutside={() => this.setState({ showUserMenu: null })}
            />
          : this.state.secondaryNavigationMenu &&
              <SecondaryNavigation
                menus={this.getMenu(currentAccountId, isEmployerGroupAccount)}
                startX={this.state.x}
                onMouseLeave={() => this.setState({ secondaryNavigationMenu: null })}
                className={`slds-p-left_xx-large slds-p-right_large slds-border_bottom${['products', 'operations', 'employerComms'].indexOf(this.state.secondaryNavigationMenu) > -1 ? ' slds-grid' : ''}`}
              />
        }
      </Fragment>
    )
  }
}

export default withRouter(GlobalNavigation)



// WEBPACK FOOTER //
// ./src/components/global-navigation/index.js